// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dodo Payments Block Styles */

.dodo-payments-block-content {
  padding: 15px;
  margin: 10px 0;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.dodo-payments-block-content p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.wc-block-payment-method__options .dodo-payments-block-content {
  margin: 15px 0;
}

/* Dodo Payments icon styling */
.wc-block-payment-method__option .dodo-payments-icon {
  max-width: 60px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/blocks/dodo-payments/style.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":["/* Dodo Payments Block Styles */\r\n\r\n.dodo-payments-block-content {\r\n  padding: 15px;\r\n  margin: 10px 0;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n}\r\n\r\n.dodo-payments-block-content p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.wc-block-payment-method__options .dodo-payments-block-content {\r\n  margin: 15px 0;\r\n}\r\n\r\n/* Dodo Payments icon styling */\r\n.wc-block-payment-method__option .dodo-payments-icon {\r\n  max-width: 60px;\r\n  height: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
